import { Box, Flex, Text } from '@elkaso-app/web-design';
import { usePageParams } from 'hooks/use-page-params';
import { useBasket } from 'pages/sales-lookup/hooks/use-basket';
import qs from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

// Sticky footer of the mobile shell: the running count of the visit basket
// and the way into the review/create screen. Hidden while the basket is empty
// and on the basket screen itself.
export const BasketBar = () => {
  const { items } = useBasket();
  const location = useLocation();
  const history = useHistory();
  const { getPageParams } = usePageParams();

  if (!items.length || location.pathname.endsWith('/basket')) return null;

  const openBasket = () => {
    const { restaurantId, restaurantName, vat, search } = getPageParams();
    history.push({
      pathname: '/app/sales-lookup/basket',
      search: qs.stringify({ restaurantId, restaurantName, vat, search }, { skipEmptyString: true }),
    });
  };

  return (
    <Box
      bg='#141927'
      px='16px'
      pt='10px'
      pb='calc(10px + env(safe-area-inset-bottom))'
      flexShrink={0}
      borderTop='1px solid'
      borderColor='whiteAlpha.200'>
      <Flex maxW='480px' mx='auto' align='center' justify='space-between'>
        <Box>
          <Text fontSize='10px' fontWeight='semibold' letterSpacing='0.12em' color='whiteAlpha.600'>
            BASKET
          </Text>
          <Text fontSize='14px' fontWeight='semibold' color='white'>
            {items.length === 1 ? '1 item' : `${items.length} items`}
          </Text>
        </Box>
        <Box
          as='button'
          bg='red.600'
          _hover={{ bg: 'red.700' }}
          px='16px'
          py='10px'
          borderRadius='12px'
          onClick={openBasket}>
          <Text fontSize='14px' fontWeight='bold' color='white'>
            Review &amp; create inquiry
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};
